<template>
  <activity-log
    title="User Logs"
    :scope="scope"
    :locked-fields="lockedFields"
    :saved-views="savedViews"
  />
</template>

<script>
import ActivityLog from '@/pages/logs/activity/index.vue'

/**
 * User Logs — sign-ins, sign-outs, MFA and page visits.
 *
 * This is the activity log with a category scope applied, not a separate screen. It used to render
 * its own table against the old `logs` collection, which held three event types and could be
 * filtered only by user and date; keeping that table alongside the new one would have left two
 * different-looking views of the same data, with the worse one reachable from the menu.
 *
 * The scope is what makes it still a distinct, useful screen rather than a duplicate of
 * "Activity": someone asking "when did this person last sign in" does not want member-profile
 * edits in the way. The unscoped log is at `activity-logs`.
 */
export default {
  name: 'UserLogs',
  components: { ActivityLog },
  data() {
    return {
      /**
       * Security is included alongside authentication because a failed sign-in and a successful one
       * are the same question asked twice — a sign-in screen that hid the failures would be the
       * least useful possible version of itself.
       */
      scope: {
        category: 'authentication,security,navigation',
      },
      // Category is fixed by the scope, so its control is hidden rather than shown as a no-op.
      lockedFields: ['category'],
      savedViews: [
        {
          label: 'Failed sign-ins',
          icon: 'AlertTriangleIcon',
          filters: { action: 'login_failed', period: '7d' },
        },
        {
          label: 'Sign-ins',
          icon: 'LogInIcon',
          filters: { action: 'login', period: '7d' },
        },
        {
          label: 'MFA activity',
          icon: 'ShieldIcon',
          filters: { module: 'mfa', period: '30d' },
        },
        {
          label: 'Lockouts',
          icon: 'LockIcon',
          filters: { action: 'account_locked', period: '30d' },
        },
        {
          label: 'Page visits',
          icon: 'EyeIcon',
          filters: { action: 'page_view', period: '24h' },
        },
      ],
    };
  },
};
</script>
